import { Link, createFileRoute } from '@tanstack/react-router'
import { Button, Paper, Stack } from '@mantine/core'
import { authClient } from '../lib/auth-client'

export const Route = createFileRoute('/no-access')({
  component: NoAccess,
})

function NoAccess() {
  const handleLogout = () => {
    authClient.signOut().then(() => {
      window.location.href = '/'
    })
  }

  return (
    <main className="flex min-h-[70vh] items-center justify-center px-4">
      <Paper withBorder radius={16} className="w-full max-w-sm p-8 text-center">
        <svg
          viewBox="0 0 16 16"
          width="32"
          height="32"
          aria-hidden="true"
          className="mx-auto mb-5 text-slate-300 dark:text-slate-700"
        >
          <rect x="0" y="0" width="7" height="7" rx="1.5" fill="currentColor" />
          <rect x="9" y="0" width="7" height="7" rx="1.5" fill="currentColor" />
          <rect x="0" y="9" width="7" height="7" rx="1.5" fill="currentColor" />
          <rect
            x="9"
            y="9"
            width="7"
            height="7"
            rx="1.5"
            className="fill-red-500 dark:fill-red-400"
          />
        </svg>
        <p className="mb-2 font-mono text-[0.62rem] font-semibold uppercase tracking-[0.16em] text-slate-400 dark:text-slate-500">
          Operator console
        </p>
        <h1 className="mb-2 text-2xl font-bold tracking-tight text-slate-900 font-stretch-[112%] dark:text-white">
          You don&apos;t have access
        </h1>
        <p className="mb-8 text-sm leading-6 text-slate-600 dark:text-slate-400">
          You&apos;re signed in, but your account is missing the admin role. Ask an administrator
          to grant it in Zitadel, then sign out and back in.
        </p>
        <Stack gap="xs">
          <Button fullWidth size="md" onClick={handleLogout}>
            Sign out
          </Button>
          <Button fullWidth size="md" variant="default" component={Link} to="/">
            Back to homepage
          </Button>
        </Stack>
      </Paper>
    </main>
  )
}
